import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, switchMap, withLatestFrom } from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';
import * as fromActions from './slice';
import { selectAllCountries } from './slice';
import { Store } from '@ngrx/store';
import { CountryService } from './country.service';

@Injectable()
export class CountryEffects {
  loadCountries$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.loadCountries),
      switchMap(() =>
        this.countryService.loadCountries().pipe(
          switchMap((countries) => of(fromActions.loadCountriesSuccess(), fromActions.upsertCountries({ entities: countries }))),
          catchError(() => of(fromActions.loadCountriesFailure()))
        )
      )
    )
  );

  loadCountriesIfNotLoadedYet$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.loadCountriesOnlyIfNotLoadedYet),
      withLatestFrom(this.store.select(selectAllCountries)),
      switchMap(([_action, countries]) => {
        if (countries.length > 0) {
          return EMPTY;
        }
        return of(fromActions.loadCountries());
      })
    )
  );

  constructor(
    private readonly store: Store,
    private readonly actions$: Actions,
    private readonly countryService: CountryService
  ) {}
}
